import SideMenu from '@/containers/side-menu/SideMenu.vue'
import OcrReport from '@/pages/ocr-report/OcrReport'

export default {
  path: '/ocr/report',
  name: 'OcrReport',
  components: {
    mainContent: OcrReport,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'ocr-reports'
    },
    breadcrumb: {
      title: 'Relatório de veículos registrados pelo OCR',
      paths: [
        { title: 'OCR' },
        { title: 'Relatório' }
      ]
    }
  }
}